export default class FriendsModalModel {

    open: boolean

    constructor() {
        this.open = false;
    }

}